import { MenuList, Paper, Popover } from '@mui/material';
import { ReactNode } from 'react';

export default function CustomPopover({
  anchorEl,
  onClose,
  children,
}: {
  anchorEl: Element | null;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={onClose}
    >
      <Paper className="menu-popover-paper">
        <MenuList>{children}</MenuList>
      </Paper>
    </Popover>
  );
}
